<template>
  <div class="Minister-top productborder margin-top1 uploadPictures">
    <div class="Minister-top-top productbackground">
      <div class="Minister-top-left product-top-color">产品安全法规图片</div>
    </div>
    <div class="productimgs">
      <div class="fluid container">
        <draggable class="list-group" tag="ul" @start="isDragging = true" @end="isDragging = false"
          :list="imgListSelect" handle=".list-group-item">
          <li class="list-group-item" v-for="(element, index) in imgListSelect" :key="element">
            <div class="mask">
              <i class="custom-icon el-icon-zoom-in" @click="handlePictureCardPreview(element)"></i>
              <i class="custom-icon el-icon-delete" @click="handleRemoveSelect(index)"></i>
            </div>
            <div class="badge">
              <img :src="element" alt />
            </div>
          </li>
          <li @click="dialogVisibleSelect = true" class="avatar-uploader" slot="footer">
            <i data-v-c660ac10 class="el-icon-plus"></i>
          </li>
        </draggable>
      </div>

      <el-row type="flex" align="middle" style="margin-top:10px;">
        <template v-if="pageType === 'download'">
          <el-button type="primary" @click="downloadImgs" style="margin-right:10px;">批量下载
          </el-button>
        </template>
        <p>
          图片可批量上传，只支持
          <span style="color:red;font-weight:bold;">GPSR图片
          </span>
          。
        </p>
      </el-row>
      <el-dialog title="选择图片" :visible.sync="dialogVisibleSelect" width="1200px">
        <draggable class="list-group" tag="ul" @start="isDragging = true" @end="isDragging = false"
          :list="imgListUpdate" handle=".list-group-item">
          <li class="list-group-item" v-for="(element, index) in imgListUpdate" :key="element.url">
            <div class="mask">
              <i class="custom-icon el-icon-zoom-in" @click="handlePictureCardPreview(element)"></i>
              <i class="custom-icon el-icon-delete" @click="handleRemoveSelect2(index)"></i>
            </div>
            <div class="badge">
              <img :src="element.url" alt />
            </div>
          </li>
          <el-upload class="upload-demo" ref="dialogSelect" accept="image/jpeg, image/tiff" drag multiple
            :action="action" list-type="picture-card" :on-success="handSuccess" :on-change="handChange"
            :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-error="handleError"
            :on-progress="handleProgress" :headers="customHeaders" :auto-upload="true">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或
              <em>选择图片</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上传GPSR图片，且不超过2M
            </div>
          </el-upload>
        </draggable>
        <!-- <div style="margin-top:20px">
          <el-button type="primary" @click="submitUpload"
            >点击上传</el-button
          >
        </div> -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleSelect = false">取 消</el-button>
          <el-button type="primary" @click="sureImg">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="dialogVisibleSee" width="500px">
        <img width="100%" :src="dialogImageUrl" alt />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { ajaxPost, Baseurl } from '../../../../api/api/api'

export default {
  components: {
    draggable,
  },
  props: {
    pageType: {
      type: String,
      default() {
        return ''
      },
    },
  },
  data() {
    return {
      action: Baseurl + 'xgImage/uploadImage',
      dialogVisibleSelect: false,
      dialogVisibleSee: false,
      dialogImageUrl: '',
      imgList: '',
      imgListUpdate: [],
      imgListSelect: [],
      isDragging: false,
      customHeaders: { token: localStorage.getItem('token') },
      updateImageList: [],
      arr: [],
    }
  },
  methods: {
    addImgList(imgArr) {
      this.imgListSelect = imgArr
      this.$emit('ImgList', this.imgListSelect)
    },
    // 父组件添加图片相应
    addImg(file) {
      this.imgListSelect.push(file)
      this.$emit('ImgList', this.imgListSelect)
    },
    sureImg() {
      this.submitUpload()
      if (this.arr == true) {
        // this.$message.success('上传成功')
        this.imgListSelect = [...this.imgListSelect, ...this.imgList]
        this.imgListUpdate = []
        this.$refs.dialogSelect.clearFiles()
        this.dialogVisibleSelect = false
        this.$emit('ImgList', this.imgListSelect)
      }
    },
    handleProgress(event, file, fileList) {
      // console.log(event)
    },
    submitUpload() {
      this.$refs.dialogSelect.submit()
    },
    handSuccess(res, file, fileList) {
      this.arr = fileList.every((item) => item.response.code === 200)
      this.imgList = this.imgListUpdate.map((item) => item.response.data)
      if (this.arr == true) {
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.data)
      }
    },
    handChange(file, fileList) {
      this.imgListUpdate = fileList
    },
    handleAvatarSuccess(response, file, fileList) {
      this.$message.success('上传成功')
      this.imgListUpdate = fileList
    },
    uploading(msg) {
      this.$message.success(msg)
    },
    handleError(err, file, fileList) {
      this.$message.error(err)
      // console.log(err)
    },
    handlePictureCardPreview(file) {
      let imageUrl = ''
      if (Object.prototype.toString.call(file) === '[object Object]') {
        imageUrl = file.response.data
      } else {
        imageUrl = file
      }
      this.dialogImageUrl = imageUrl
      this.dialogVisibleSee = true
    },
    handleRemove(file, fileList) {
      this.imgListUpdate = fileList
    },
    handleRemoveSelect(index) {
      this.$nextTick(() => {
        let imgInfo = this.imgListSelect[index]
        let deleteImage = (imgInfo.lastIndexOf('/') + 1)
        deleteImage = imgInfo.substring(deleteImage, imgInfo.length)
        let deleteFiles = []
        deleteFiles.push(deleteImage)
        this.imgListSelect.splice(index, 1)
        // let API = Baseurl + 'xgImage/deleteImage'
        // ajaxPost(API, { objectNames: deleteFiles })
        //   .then((res) => {
        //     if (res.data.code == 200) {
        //       this.$message.success('删除图片成功!')
        //     } else {
        //       this.$message.error(res.data.data || '删除图片失败!')
        //     }
        //   })
        //   .catch((e) => {
        //     console.log(e)
        //   })
        deleteFiles = []
      })
    },
    handleRemoveSelect2(index) {
      this.$nextTick(() => {
        let imgInfo = this.imgListUpdate[index].response.data
        let deleteImage = (imgInfo.lastIndexOf('/') + 1)
        deleteImage = imgInfo.substring(deleteImage, imgInfo.length)
        let deleteFiles = []
        deleteFiles.push(deleteImage)
        this.imgListUpdate.splice(index, 1)
        // let API = Baseurl + 'xgImage/deleteImage'
        // ajaxPost(API, { objectNames: deleteFiles })
        //   .then((res) => {
        //     if (res.data.code == 200) {
        //       this.$message.success('删除图片成功!')
        //     } else {
        //       this.$message.error(res.data.data || '删除图片失败!')
        //     }
        //   })
        //   .catch((e) => {
        //     console.log(e)
        //   })
        deleteFiles = []
      })
    },
    downloadImgs() {
      this.$emit('downloadImgs')
    },
  },
}
</script>

<style lang="scss" scoped>
.uploadPictures {
  /deep/ .el-upload-list__item {
    width: 178px;
    height: 178px;
  }

  /deep/ .el-upload--picture-card {
    width: 178px;
    height: 178px;
    line-height: 178px;
    padding: 0 20px;
  }

  /deep/ .selectUpload {
    // .el-upload.el-upload--picture-card,
    .el-upload-list__item-status-label {
      display: none;
    }
  }

  /deep/ .upload-demo {
    .el-upload-list--picture-card.el-upload-list {
      display: none;
    }

    .el-upload--picture-card {
      line-height: initial;

      .el-upload-dragger {
        width: 100%;
        height: 100%;
        border: none;
      }
    }
  }

  /deep/ .el-dialog__body {
    word-break: break-word;
  }

  .flip-list-move {
    transition: transform 0.5s;
  }

  .no-move {
    transition: transform 0s;
  }

  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }

  .list-group {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;

    .list-group-item {
      width: 178px;
      height: 178px;
      background-color: #fbfdff;
      border: 1px dashed #c0ccda;
      border-radius: 6px;
      box-sizing: border-box;
      cursor: pointer;
      margin-right: 10px;
      margin-bottom: 10px;
      // float: left;
      position: relative;
      overflow: hidden;

      .mask {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        transition-duration: 0.5s;

        .custom-icon {
          font-size: 20px;
          margin: 0 8px;
          color: #fff;
        }
      }

      &:hover .mask {
        opacity: 1;
        border-color: #409eff;
      }
    }

    .list-group-item img {
      width: 100%;
      height: 100%;
    }
  }

  .showImg {
    width: 148px;
    float: left;
    margin-right: 15px;
  }

  .avatar-uploader {
    width: 178px;
    height: 178px;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    text-align: center;
    line-height: 178px;
    font-size: 40px;

    &:hover {
      border-color: #409eff;
    }
  }
}
</style>
